import { render, staticRenderFns } from "./accompanyingPassportView.vue?vue&type=template&id=49ee2da4&scoped=true&"
import script from "./accompanyingPassportView.vue?vue&type=script&lang=js&"
export * from "./accompanyingPassportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee2da4",
  null
  
)

export default component.exports